import Icon from '@components/icons';
import { Card } from '@screens/landing-page-tools/types';
import * as Styles from '@screens/lp-default/components/tools/components/accordion-card/styles';
import { useState } from 'react';

type CardProps = {
  card: Card;
  isExpanded: boolean;
  onExpand: (title: string, id: number) => void;
};

export default function AccordionCard({ card, isExpanded, onExpand }: CardProps) {
  const [isClicked, setIsClicked] = useState(false || null);

  const handleClick = () => {
    setIsClicked(card.id);
    setTimeout(() => {
      onExpand(card.title, card.id);
      setIsClicked(null);
    }, 200);
  };
  return (
    <Styles.ToolCard isExpanded={isExpanded} data-testid="accordion-card" onClick={() => handleClick()}>
      <Styles.ToolCardTitle isExpanded={isExpanded}>{card.title}</Styles.ToolCardTitle>
      <Styles.ToolCardTitleBottom isExpanded={isExpanded}>{card.title}</Styles.ToolCardTitleBottom>
      <Styles.ToolCardDescription isExpanded={isExpanded}>{card.description}</Styles.ToolCardDescription>
      <Styles.ToolCardBackground isExpanded={isExpanded}>
        <source media="(max-width: 1023px)" srcSet={`/images/default-landing-page/tools/${card.images.xl}`} />
        <source media="(max-width: 663px)" srcSet={`/images/default-landing-page/tools/${card.images.xl}`} />
        <img
          srcSet={`/images/default-landing-page/tools/${card.images.xl}`}
          alt={`/images/default-landing-page/tools/${card.images.xl}`}
        />
      </Styles.ToolCardBackground>
      <Styles.ToolCardButton isExpanded={isExpanded} isClicked={isClicked} data-testid="accordion-card-button">
        <Icon icon="plus" size={12} />
      </Styles.ToolCardButton>
    </Styles.ToolCard>
  );
}
